import { useModal, Icons } from '@pankod/refine-antd'
import { Modal, Button, Input } from 'antd'
import { useEffect, useState } from 'react'
const { FileSearchOutlined } = Icons

export const ReferenceDetailsPreview: React.FC<{ referenceText: string; setReferenceTextDetails: React.Dispatch<React.SetStateAction<string>> }> = ({
  referenceText,
  setReferenceTextDetails,
}) => {
  const { show, modalProps } = useModal()
  const [newReferenceText, setNewReferenceText] = useState(referenceText)

  const handleModalCancel = (e: React.MouseEvent<HTMLElement>) => {
    setNewReferenceText(referenceText)
    if (modalProps.onCancel) {
      modalProps.onCancel(e)
    }
  }
  useEffect(() => {
    show()
  }, [])

  return (
    <>
      <Button
        type="primary"
        shape="circle"
        style={{
          backgroundColor: '#38D2D2',
          backgroundImage: 'radial-gradient(100% 100% at 100% 0, #5adaff 0, #5468ff 100%)',
          borderColor: 'white',
          marginLeft: '10px',
        }}
        icon={<FileSearchOutlined />}
        size={'middle'}
        onClick={show}
      />
      <Modal
        {...modalProps}
        title="Reference Text Preview"
        closable={false}
        footer={[
          <Button key="back" onClick={handleModalCancel}>
            Return
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={e => {
              setReferenceTextDetails(newReferenceText || '')
              if (modalProps.onCancel) modalProps.onCancel(e)
            }}
          >
            Save
          </Button>,
        ]}
      >
        <Input.TextArea
          value={newReferenceText}
          rows={12}
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          onChange={e => setNewReferenceText(e.target.value)}
        />
      </Modal>
    </>
  )
}
